import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import classnames from 'classnames'
import { fetchStudents, uploadMarks } from '../../redux/action/facultyAction'
import FacultyHomeHelper from '../../Components/FacultyHomeHelper'
import { useHistory, Link } from 'react-router-dom';



const FacultyUploadMarks = () => {
    const store = useSelector((store) => store)
    const history = useHistory()
    const dispatch = useDispatch() 
    const [isLoading, setIsLoading] = useState(false);
    const [year, setYear] = useState("")
    const [semester, setSemester] = useState("")
    const [marks, setMarks] = useState([])
    const [section, setSection] = useState("")
    const [subjectCode, setSubjectCode] = useState("")
    const [totalMarks, setTotalMarks] = useState()
    const [exam ,setExam] = useState("")
    const [error, setError] = useState({})
    const [errorHelper, setErrorHelper] = useState({})

   const department = store.faculty.faculty.faculty.department;

    const handleInputChange = (value, _id) => {
    
        const newMarks = [...marks]
        let index = newMarks.findIndex(m => m._id === _id)
        if (index === -1) {
            newMarks.push({ _id, value })
        }
        else {
           newMarks[index].value = value
        }
        setMarks(newMarks)
    }

    useEffect(() => {
        if (store.error) {
            setError(store.error)
        }
    }, [store.error])

    useEffect(() => {
        if (store.errorHelper) {
            setErrorHelper(store.errorHelper)
        }
    }, [store.errorHelper])

    const formHandler = (e) => {
        e.preventDefault()
    
       dispatch(fetchStudents(department, year,  section ,semester))

    }

    
    const secondFormHandler = (e) => {
        e.preventDefault()
        dispatch(uploadMarks(subjectCode, exam, totalMarks, marks, department, section ,semester
            ))
            console.log(semester)
    }

    return (
        <div>
          {store.faculty.isAuthenticated && (
            <div className="container-fluid p-0">
              <div className="d-flex">
                <div className="print-helper">
                  <FacultyHomeHelper />
                </div>
                <div className="mx-1 w-100">
                  <div className='px-3 py-1 bg-light d-flex align-items-center justify-content-between'>
                  <h5><Link to='/uploadMarks' className='text-light'><img src="/image/Back.svg" className='p-2' alt="" /></Link></h5>
                    <h3> <img src="/logo192.png" width={'50px'} alt="" />Upload Marks</h3>
                    <button onClick={()=> window.print()} type="button" className=" btn-success btn text-light"> <img src="/image/print.svg" lt="" /> Download</button>
                  </div>
                    <div className="col d-md-flex align-items-center justify-content-between ">
                      <form
                        className="d-md-flex align-items-center justify-content-start"
                        noValidate
                        onSubmit={formHandler}
                      >
                                <div className="form-group mx-2 print-helper">
                                <label htmlFor="yearId">Year</label>
                                <select
                                    onChange={(e) => setYear(e.target.value)}
                                    className={classnames('form-control', {
                                    'is-invalid': error.year
                                    })}
                                    id="yearId"
                                >
                                    <option>Select</option>
                                    <option value="I">1</option>
                                    <option value="II">2</option>
                                    <option value="III">3</option>
                                    <option value="IV">4</option>
                                </select>
                                {error.year && (
                                    <div className="invalid-feedback">{error.year}</div>
                                )}
                                </div>
                                <div className="form-group mx-2 print-helper">
                                <label htmlFor="sectionId">Section</label>
                                <select
                                    onChange={(e) => {
                                    setSection(e.target.value);
                                    }}
                                    className={classnames('form-control', {
                                    'is-invalid': error.section
                                    })}
                                    id="sectionId"
                                >
                                    <option>Select</option>
                                    <option value="A">A</option>
                                    <option value="B">B</option>
                                    <option value="C">C</option>
                                    <option value="D">D</option>
                                </select>
                                {error.section && (
                                    <div className="invalid-feedback">{error.section}</div>
                                )}
                                </div>
                                <div className="form-group mx-2 print-helper">
                                <label htmlFor="semesterId">Semester</label>
                                <select
                                    onChange={(e) => {
                                    setSemester(e.target.value);
                                    }}
                                    className={classnames('form-control', {
                                    'is-invalid': error.section
                                    })}
                                    id="semesterId"
                                >
                                    <option>Select</option>
                                    <option value="1">1</option>
                                    <option value="2">2</option>
                                    <option value="3">3</option>
                                    <option value="4">4</option>
                                    <option value="5">5</option>
                                    <option value="6">6</option>
                                    <option value="7">7</option>
                                    <option value="8">8</option>
                                </select>
                                {error.semester && (
                                    <div className="invalid-feedback">{error.semester}</div>
                                )}
                                </div>
                                <div className="mt-3">
                                {!isLoading && (
                                    <button
                                    type="submit"
                                    className="btn btn-info btn-block print-helper "
                                    >
                                    <img
                                        src="/image/search.svg"
                                        className="mb-1"
                                        alt=""
                                    />{' '}
                                    Search
                                    </button>
                                )}
                                {isLoading && (
                                    <div
                                    className="spinner-border text-primary"
                                    role="status"
                                    >
                                    <span className="sr-only">Loading...</span>
                                    </div>
                                )}
                                </div>
                                </form>
                </div>

                <div className="row justify-content-center m-0">
                  <div className="col">
                    <form onSubmit={secondFormHandler}>
                            <div  className="d-md-flex align-items-center justify-content-start">
                            <div className="form-group mx-3">
                                <label htmlFor="subjectId">Subject Name</label>
                                <select
                                    onChange={(e) => setSubjectCode(e.target.value)}
                                    className={classnames("form-control", {
                                    'is-invalid': errorHelper.subjectCode
                                    })}
                                    id="subjectId"
                                >
                                    <option>Select</option>
                                    {store.faculty.allSubjectCodeList.subjectCode?.map((subject, index) => (
                                        <option key={subject} value={subject}>
                                            {store.faculty.allSubjectCodeList.subjectName?.[index]}
                                        </option>
                                        ))}
                                </select>
                                {errorHelper.subjectCode && (<div classNameName="invalid-feedback">{errorHelper.subjectCode}</div>)}
                            </div>
                            <div className="form-group mx-3">
                                <label htmlFor="examId">Exam</label>
                                <select onChange={(e) => setExam(e.target.value)} value={exam} className={classnames("form-control",
                                    {
                                        'is-invalid': errorHelper.exam

                                    })} id="examId">
                                    <option>Select</option>
                                    <option value="CycleTest1">Cycle Test 1</option>
                                    <option value="CycleTest2">Cylce Test 2</option>
                                    <option value="ModelExam">Model Exam</option>
                                </select>
                                {errorHelper.exam && (<div classNameName="invalid-feedback">{errorHelper.exam}</div>)}
                            </div>
                            <div className="form-group mx-3">
                                <label htmlFor="marksId">Total Marks</label>
                                <input type="number" className={classnames("form-control",
                                    {
                                        'is-invalid': errorHelper.totalMarks

                                    })} id="marksId"
                                    value={totalMarks} onChange={(e) => setTotalMarks(e.target.value)} />
                                {errorHelper.totalMarks && (<div classNameName="invalid-feedback">{errorHelper.totalMarks}</div>)}
                            </div>
                            </div>

                            <table className="table table-bordered table-striped">
                                <thead className="thead-dark">
                                    <tr>
                                        <th scope="col">S.NO</th>
                                        <th scope="col">Registration Number</th>
                                        <th scope="col">Student Name</th>
                                        <th scope="col">Marks</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        store.faculty.fetchedStudents.map((obj, index) =>
                                            <tr key={index}>
                                                <td>{index+1}</td>
                                                <td>{obj.registrationNumber}</td>
                                                <td>{obj.name}</td>
                                                <td>
                                                <div className="form-check">
                                                    <input
                                                        className="form-control"
                                                        required
                                                        type="text"
                                                        pattern="[0-9]{1,2}"
                                                        value={obj.marks}
                                                        onChange={(e) => handleInputChange(e.target.value, obj._id)}
                                                        id="defaultCheck1"
                                                    />
                                                </div>
                                            </td>
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                            <button type="submit" className="btn btn-primary ml-1">Submit</button>
                         </form>
                  </div>
                </div>
              
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default FacultyUploadMarks;
